import React, { useState } from "react";
import { useFormik } from "formik";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import * as Roles from "../../../services/roles.services";
import Breadcrums from "../../../common/breadcrumbs";
import { useTranslation } from "react-i18next";
import {
    SWAL_SETTINGS,
} from "../../../../../utils/Constants";
import {
    globalLoader,
    groupPermissions,
    handleServerValidations,
} from "../../../../../utils/commonfunction";
import * as Yup from "yup";
import CustomError from "../../../../../utils/customError";
import { useEffect } from "react";

const RoleAdd = () => {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const [submitted, setSubmitted] = useState(false);
    const [permissions, setPermissions] = useState([]);

    const breadcrumbs = [
        { title: t("sidebar_link_dashboard"), url: "/admin/dashboard" },
        {
            title: 'Roles',
            url: "/admin/permission-management/roles/list/1",
        },
        { title: t("link_add"), url: "" },
    ];

    const validationSchema = Yup.object().shape({
        title: Yup.string()
            .trim()
            .required(t("label_title_error"))
            .max(60, t("label_title_length_error"))
            .test("no-spaces", "label_title_error", (value) => value && value.trim().length > 0),
        permissionIDs: Yup.array().min(1, "Select at least one permission")
    });

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            title: "",
            permissionIDs: []
        },
        validateOnBlur: false,
        validationSchema: validationSchema,
        onSubmit: (values, { setSubmitting, resetForm }) => {
            globalLoader(true);
            setSubmitted(true);
            let formData = new FormData();
            formData.append("title", values.title);
            formData.append("permissionIDs", JSON.stringify(values.permissionIDs));


            Roles.Add(formData).then((response) => {
                console.log("response",response);
                
                setSubmitting(false);
                if (response.success) {
                    Swal.fire({
                        icon: "success",
                        text: response.message,
                        ...SWAL_SETTINGS,
                    });
                    globalLoader(false);
                    resetForm({ values: "" });
                    navigate(`/admin/permission-management/roles/list/1`);
                } else {
                    Swal.fire({
                        icon: "error",
                        text: handleServerValidations(response),
                        ...SWAL_SETTINGS,
                    });
                    setSubmitted(false);
                    globalLoader(false);
                }
            })
                .catch((error) => {
                    console.log("error ====> ", error);
                    globalLoader(false);
                    setSubmitted(false);
                    Swal.fire({
                        icon: "error",
                        text: handleServerValidations(error),
                        ...SWAL_SETTINGS,
                    });
                });
        },
    });

    useEffect(() => {
        Roles.Options().then(res => {
            if (res.success) {
                setPermissions(res.data);
            }
        });
    }, []);

    const handlePermissionChange = (e, id) => {
        const selected = [...formik.values.permissionIDs];
        if (e.target.checked) {
            if (!selected.includes(id)) {
                formik.setFieldValue(
                    "permissionIDs",
                    [...selected, id]
                );
            }
        } else {
            formik.setFieldValue("permissionIDs", selected.filter(pid => pid !== id));
        }
    };

    const isAllSelected = (data) => {
        for (let i = 0; i < data.length; i++) {
            if (!formik.values.permissionIDs.includes(data[i].id)) {
                return false;
            }
        }
        return true;
    };
    const handleSelectAll = (e, data) => {
        let selected = [...formik.values.permissionIDs];
        if(e.target.checked){
            data.forEach((item) => {
                if(!selected.includes(item.id)){
                    selected.push(item.id);
                }
            });
        }else{
            data.forEach((item) => {
                if(selected.includes(item.id)){
                    selected = selected.filter(pid => pid !== item.id);
                }
            });
        }
        formik.setFieldValue("permissionIDs", selected);
    };
    return (
        <>
            <Breadcrums data={breadcrumbs} />
            <form onSubmit={formik.handleSubmit}>
                <div className="row row-sm">
                    <div className="col-lg-12 col-md-12 animation_fade">
                        <div className="card custom-card">
                            <div className="card-body">
                                <div>
                                    <h6 className="main-content-label mb-3">
                                        {t("link_add")} Role
                                    </h6>
                                  
                                     <p 
                                    style={
                                        {
                                            color: "red"
                                        }
                                    }
                                    ><b>Note:- </b>Please select the “List” permission before choosing any additional actions.</p>
                                </div>
                                <div className="row row-sm">
                                    <div className="col-md-12 text-center form-group">
                                        <label htmlFor="question" className="text-left d-flex">
                                            {t("label_title")}:
                                            <span className="requirestar">*</span>{" "}
                                        </label>
                                        <input
                                            name="title"
                                            id="title"
                                            type="text"
                                            placeholder="Enter the title"
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            value={formik.values.title}
                                            className="form-control"
                                        />
                                        <span className="text-danger d-flex text-left">
                                            <CustomError name="title" form={formik} />
                                        </span>
                                    </div>
                                    <div className="col-md-12 form-group mt-3 no-select">
                                        <label className="text-left d-flex">
                                            Permissions: <span className="requirestar">*</span>
                                        </label>
                                        <div className="card">
                                            <div className="card-body p-3">
                                                {permissions && permissions.length ?
                                                    <>
                                                        {groupPermissions(permissions).map((group, index) => (
                                                            <div className="" key={index}>
                                                                {index !== 0 && <hr className="border-dark" />}
                                                                <div className="d-block">
                                                                    <label className="ckbox d-inline-block fw-bold"><input className="mr-2 cp" type="checkbox" 
                                                                    checked={isAllSelected(group?.data)}
                                                                        onChange={(e) => handleSelectAll(e, group.data)}/><span className="ps-1">{group.title || "Default"}</span></label>
                                                                </div>
                                                                {
                                                                    group?.data?.map((perm, i) => (
                                                                        <div className="position-relative d-inline-block me-3" key={i}>
                                                                            <label class="ckbox d-inline-block cp no-select"><input className="mr-2 cp" checked={formik.values.permissionIDs.includes(perm.id)}
                                                                                onChange={(e) => handlePermissionChange(e, perm.id)} type="checkbox"/><span class="ps-1">{perm.title}</span></label>
                                                                        </div>
                                                                    ))
                                                                }
                                                            </div>

                                                        ))}
                                                    </>
                                                    : null}
                                            </div>
                                        </div>
                                        <span className="text-danger d-flex text-left">
                                            <CustomError name="permissionIDs" form={formik} />
                                        </span>
                                    </div>
                                    <div className="mt-5">
                                        <button
                                            className="btn btn-info mr-2"
                                            type="submit"
                                            disabled={submitted ? true : null}
                                        >
                                            <i className="ace-icon fa fa-check bigger-110 mx-1"></i>
                                            {t("btn_submit")}
                                        </button>
                                        <button
                                            className="btn ripple btn-secondary"
                                            type="button"
                                            disabled={submitted ? true : null}
                                            onClick={() => navigate(-1)}
                                        >
                                            <i className="ace-icon fa fa-times bigger-110 mx-1"></i>
                                            {t("btn_cancel")}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </>
    );
};

export default RoleAdd;